import {OrderSheetPageSet, OrderSheetPageSetType} from '@web/core/constants'
import getApi, {createApiAsyncThunk, createWrapper, getCommonBaseUrl} from '@web/helpers/api'
import {CommonState, pageSetInfoSelector} from '@web/slices/common/slice'

import {AgreeError, OpenBankAgreeResponse} from './interfaces'

type RootState = {
    common: CommonState
}

const OrderChannelGroup: OrderSheetPageSetType[] = [
    OrderSheetPageSet.MALL,
    OrderSheetPageSet.EASYBOOKING,
    OrderSheetPageSet.SELLER,
    OrderSheetPageSet.FAMILY_PAY,
]

const api = getApi(getCommonBaseUrl())

/** 계좌간편결제 정보 재조회 */
export const agreeToOpenBank = createApiAsyncThunk<
    boolean,
    void,
    {
        state: RootState
        rejectValue: Maybe<AgreeError>
    }
>('agreementInfo/agreeToOpenBank', async (_, {getState}) => {
    const state = getState()
    const {orderSheetPageSet} = pageSetInfoSelector(state)
    const result = await createWrapper<OpenBankAgreeResponse>(
        api.post('/user/agreeOpenBank', {
            agreeInflow: (function () {
                if (orderSheetPageSet && OrderChannelGroup.includes(orderSheetPageSet)) {
                    return 'SHOPPING'
                }
                return 'CONTENTS'
            })(),
        }),
    )
    return result.resultCode === '1000'
})
